export enum Column {
  Status = 'Status',
  Date = 'Date',
  Receiver = 'Receiver',
  Org = 'Org',
  Value = 'Value',
  Action = 'Action'
}
